__turbopack_context__.v({
  "leaders": "VideoListing-module-scss-module__KK8MNa__leaders",
  "leaders__listing": "VideoListing-module-scss-module__KK8MNa__leaders__listing",
  "leadership__hero": "VideoListing-module-scss-module__KK8MNa__leadership__hero",
  "poster__img": "VideoListing-module-scss-module__KK8MNa__poster__img",
});
